import { PlanDetails } from "../PlanDetails";
import {
  useUpgradeFlowFormContext,
  useUpgradeFlowShellContext,
} from "../UpgradeFlowContext";

export const PlanDetailsRoute = () => {
  const { modal, subheading } = useUpgradeFlowShellContext();
  const { onSubmitHandlerPlanDetails } = useUpgradeFlowFormContext();

  return (
    <PlanDetails
      subheading={subheading}
      hideModal={modal.hide}
      onSubmitHandler={onSubmitHandlerPlanDetails}
    />
  );
};
